import _ from "lodash";
import update from "immutability-helper";
import { downloadFromUrl } from "modules/Services";
import { updateSettings } from "modules/ConfigurationThunks";
import { getSelectedCurriculumObject } from "Administrator/modules/Utils";
import ACLStore from "lib/aclStore";
import { MODULES } from "lib/staffPermissionUtils";
import { STAFF, STUDENT } from "Constants/stringConstants";
import client from "lib/apolloClient/client";
import { exportData, getIsStudentPronounsEnabled } from "Utils";
import { setToastMsg, logBulkActionActivity } from "Login/modules/LoginModule";
import { getUserInfo } from "Login/modules/LoginModule/LoginUtils";
import { isHomeroomEnabled } from "StudentSetup/modules/StudentsModule";
import { getOgranizationDataQuery } from "./Queries";
import moment from "moment";
import { getSettingValue } from "modules/PermissionModule";
import { colors } from "Constants";
import { getUserSortOptions } from "Utils/GetFormattedUserName";
import UserAccessPoint, {
  ACCESS_POINT_MODULE,
  isAccessPointEnable,
} from "MessagingV2/components/UserAccessPoint";
import { ENABLE_ROLES_AND_PERMISSIONS_CONFIGURATION } from "Constants/permissionConstants";
import {
  canImpersonateStaff,
  canLogoutStaff,
  canManageClassRoster,
  canManageSchoolRoster,
  canManageSuperAdmins,
  canResetStudentCodeAndFamilyInviteInSchoolRoster,
  canViewStudentCodeAndFamilyInviteInSchoolRoster,
} from "SchoolSetup/modules/Utils";
import {
  isBulkActionsEnabled,
  getIsEnrollWithdrawalDateEnabled,
  getIsStudentMiddleNameEnabled,
  getIsUserMiddleNameEnabled,
  getIsUserPrefixEnabled,
  getIsUserPronounsEnabled,
  getIsMultipleHomeroomAdvisorsEnabled,
  getIsMfaEnabled,
} from "Utils/ACLStoreUtils";
import { getRnPLevelLabelLocale } from "RolesAndPermissions/modules/RolesAndPermissionsUtils";
import { isUserMiddleNameEnabled } from "Platform/modules/PlatformUtils";

export const NAME = "schoolSetup";
export const AYT_INITIATED_STATES = [
  "YEAR_GROUP_CONFIGURED",
  "REVIEW_COMPLETED",
];

export const TOGGLE_CONFIGURE_COLUMNS_MODAL =
  "TOGGLE_CONFIGURE_COLUMNS_MODAL" + " " + NAME;
export const UPDATE_SORT_ORDER = "UPDATE_SORT_ORDER" + " " + NAME;
const SCHOOL_ENTITY_MODAL_INIT_STATE =
  "SCHOOL_ENTITY_MODAL_INIT_STATE" + " " + NAME;
const UPDATE_SCHOOL_ENTITY_MODAL_DATA =
  "UPDATE_SCHOOL_ENTITY_MODAL_DATA" + " " + NAME;
const UPDATE_SCHOOL_ENTITY_MODAL_FILTERS =
  "UPDATE_SCHOOL_ENTITY_MODAL_FILTERS" + " " + NAME;
const UPDATE_SELECTED_CURRICULUM = "UPDATE_SELECTED_CURRICULUM" + " " + NAME;
const RESET_SCHOOL_ENTITY_MODAL_FILTERS =
  "RESET_SCHOOL_ENTITY_MODAL_FILTERS" + NAME;
const UPDATE_ADD_ENTITY_MODAL_SELECTED_ITEMS =
  "UPDATE_ADD_ENTITY_MODAL_SELECTED_ITEMS" + " " + NAME;
const UPDATE_ADD_ENTITY_MODAL_EXCLUDED_ITEMS =
  "UPDATE_ADD_ENTITY_MODAL_EXCLUDED_ITEMS" + " " + NAME;
const UPDATE_ADD_ENTITY_MODAL_SELECTED_ITEMS_COUNT =
  "UPDATE_ADD_ENTITY_MODAL_SELECTED_ITEMS_COUNT" + " " + NAME;
const UPDATE_ADD_ENTITY_MODAL_SELECTED_ALL_OPTIONS =
  "UPDATE_ADD_ENTITY_MODAL_SELECTED_ALL_OPTIONS" + " " + NAME;
const UPDATE_ADD_ENTITY_MODAL_SELECTED_ITEMS_AND_SUBJECT_LEVELS_MAPPING =
  "UPDATE_ADD_ENTITY_MODAL_SELECTED_ITEMS_AND_SUBJECT_LEVELS_MAPPING" +
  " " +
  NAME;
const UPDATE_ADD_ENTITY_MODAL_SHOW_ADDITIONAL_FILTERS =
  "UPDATE_ADD_ENTITY_MODAL_SHOW_ADDITIONAL_FILTERS" + " " + NAME;
const UPDATE_ADD_ENTITY_MODAL_SELECTED_ITEMS_LIST =
  "UPDATE_ADD_ENTITY_MODAL_SELECTED_ITEMS_LIST" + " " + NAME;
const RESET_ADD_ENTITY_MODAL_OBJ = "RESET_ADD_ENTITY_MODAL_OBJ" + " " + NAME;

export const ENTITY_EMAIL_ALREADY_EXISTS_USER_DATA =
  "ENTITY_EMAIL_ALREADY_EXISTS_USER_DATA" + " " + NAME;

export const RESET_ENTITY_EMAIL_ALREADY_EXISTS_USER_DATA =
  "RESET_ENTITY_EMAIL_ALREADY_EXISTS_USER_DATA" + " " + NAME;

export const toggleConfigureColumnsModal = () => {
  return { type: TOGGLE_CONFIGURE_COLUMNS_MODAL };
};

export const updateSortOrder = payload => {
  return { type: UPDATE_SORT_ORDER, payload };
};

export const schoolEntityModalInit = () => {
  return { type: SCHOOL_ENTITY_MODAL_INIT_STATE };
};

export const updateSchoolEntityModalDetails = payload => {
  return { type: UPDATE_SCHOOL_ENTITY_MODAL_DATA, payload };
};

export const updateSchoolEntityModalFilters = payload => {
  return { type: UPDATE_SCHOOL_ENTITY_MODAL_FILTERS, payload };
};

export const resetSchoolEntityModalFilters = () => {
  return { type: RESET_SCHOOL_ENTITY_MODAL_FILTERS };
};

export const updateSelectedCurriculum = payload => {
  return { type: UPDATE_SELECTED_CURRICULUM, payload };
};

export const updateAddEntityModalSelectedItems = data => {
  return { type: UPDATE_ADD_ENTITY_MODAL_SELECTED_ITEMS, data };
};

export const updateAddEntityModalExcludedItems = data => {
  return { type: UPDATE_ADD_ENTITY_MODAL_EXCLUDED_ITEMS, data };
};

export const updateAddEntityModalSelectedItemsCount = data => {
  return { type: UPDATE_ADD_ENTITY_MODAL_SELECTED_ITEMS_COUNT, data };
};

export const updateAddEntityModalSelectedAllOptions = data => {
  return { type: UPDATE_ADD_ENTITY_MODAL_SELECTED_ALL_OPTIONS, data };
};

export const updateAddEntityModalSelectedItemsAndSubjectLevelsMapping = data => {
  return {
    type: UPDATE_ADD_ENTITY_MODAL_SELECTED_ITEMS_AND_SUBJECT_LEVELS_MAPPING,
    data,
  };
};

export const updateAddEntityModalShowAdditionalFilters = data => {
  return {
    type: UPDATE_ADD_ENTITY_MODAL_SHOW_ADDITIONAL_FILTERS,
    data,
  };
};
export const updateAddEntityModalSelectedItemsList = data => {
  return {
    type: UPDATE_ADD_ENTITY_MODAL_SELECTED_ITEMS_LIST,
    data,
  };
};

export const resetAddEntityModalObj = () => {
  return { type: RESET_ADD_ENTITY_MODAL_OBJ };
};

export const addEntityEmailAlreadyExistsUserData = data => {
  return { type: ENTITY_EMAIL_ALREADY_EXISTS_USER_DATA, payload: data };
};

export const resetEntityEmailAlreadyExistsUserData = data => {
  return { type: RESET_ENTITY_EMAIL_ALREADY_EXISTS_USER_DATA, payload: data };
};

export const getTableSortOrder = ({ sortedFieldsWithOrder }) => {
  const { direction, menuItemEntity } =
    _.head(_.values(sortedFieldsWithOrder)) || {};
  if (_.isEmpty(menuItemEntity))
    return { orderBy: "UPDATED_AT", orderByDirection: "DESC" };
  return { orderBy: menuItemEntity, orderByDirection: direction };
};
const getConfigureColumnsConfig = (isMYP = false) => {
  return {
    defaultSetupTableColumns: {
      STUDENTS: ["programme", "course", "studentSignInCode", "families"],
      CLASSES: isMYP
        ? ["staffs", "grades", "students", "subject"]
        : ["staffs", "grades", "students"],
      STAFF: ["sourceId", "displayRole", "rnpRoles", "course"],
    },
    tableToSettingsMap: {
      STUDENTS: "AdminStudentsTableColumns",
      CLASSES: "AdminClassesTableColumns",
      STAFF: "AdminStaffTableColumns",
    },
  };
};

const CLASS_ROSTER_CSV_COLUMN_WIDTHS = {
  Staff: {
    Classes: 45,
  },
  Classes: {
    Staff: 40,
    Students: 40,
  },
  Students: {
    Classes: 35,
  },
  Family: {
    "Student classes": 45,
  },
};

// A duplicate of the same is present in ReviewerSetupModule.js
export const USER_NAME_SORT_OPTIONS = [
  {
    key: "FIRSTNAME_AZ",
    label: "common:first_name_az",
    sortEntity: "FIRST_NAME",
    direction: "ASC",
  },
  {
    key: "FIRSTNAME_ZA",
    label: "common:first_name_za",
    sortEntity: "FIRST_NAME",
    direction: "DESC",
  },
  {
    key: "LASTNAME_AZ",
    label: "common:last_name_az",
    sortEntity: "LAST_NAME",
    direction: "ASC",
  },
  {
    key: "LASTNAME_ZA",
    label: "common:last_name_za",
    sortEntity: "LAST_NAME",
    direction: "DESC",
  },
];

export const USER_NAME_SORT_OPTIONS_V2 = [
  {
    key: "FIRSTNAME_AZ",
    label: "common:first_name_az",
    sortEntity: "FIRST_NAME",
    direction: "ASC",
  },
  {
    key: "FIRSTNAME_ZA",
    label: "common:first_name_za",
    sortEntity: "FIRST_NAME",
    direction: "DESC",
  },
  {
    key: "MIDDLENAME_AZ",
    label: "common:middle_name_az",
    sortEntity: "MIDDLE_NAME",
    direction: "ASC",
  },
  {
    key: "MIDDLENAME_ZA",
    label: "common:middle_name_za",
    sortEntity: "MIDDLE_NAME",
    direction: "DESC",
  },
  {
    key: "LASTNAME_AZ",
    label: "common:last_name_az",
    sortEntity: "LAST_NAME",
    direction: "ASC",
  },
  {
    key: "LASTNAME_ZA",
    label: "common:last_name_za",
    sortEntity: "LAST_NAME",
    direction: "DESC",
  },
  {
    key: "FULLNAME_AZ",
    label: "common:full_name_az",
    sortEntity: "FULL_NAME",
    direction: "ASC",
  },
  {
    key: "FULLNAME_ZA",
    label: "common:full_name_za",
    sortEntity: "FULL_NAME",
    direction: "DESC",
  },
];

const getFinalColumnList = ({
  columnList,
  excludedColumnIds,
  configuredColumns,
  showConfigurableColumns,
  customProps,
  requiredColumns,
  checkboxColumn,
}) => {
  // filtered configureable columns
  const configurableColumns = _.filter(columnList, ({ id, visible }) => {
    return !_.includes(excludedColumnIds, id) && visible;
  });

  // Ordering the columns based on the order the user selected - required for both the table and the configuring modal
  const orderedColumns = _.reduce(
    configuredColumns,
    (result, id) => {
      const column = _.head(_.remove(configurableColumns, { id }));
      if (column) result.push(column);
      return result;
    },
    []
  );

  // Appending the unselected columns to the end of the list
  if (showConfigurableColumns) {
    orderedColumns.push(...configurableColumns);
  } else {
    // Insert ordered columns before action column
    const insertionIndex =
      requiredColumns.length > 1 ? requiredColumns.length - 1 : 1;
    requiredColumns.splice(insertionIndex, 0, ...orderedColumns);
  }

  const finalColumns = _.map(
    showConfigurableColumns ? orderedColumns : requiredColumns,
    item => {
      const extraProps = _.get(customProps, [item.id], {});
      return { ...item, ...extraProps };
    }
  );

  if (!showConfigurableColumns) {
    const isCheckboxVisible =
      checkboxColumn && _.get(checkboxColumn, "visible");
    return isCheckboxVisible ? [checkboxColumn, ...finalColumns] : finalColumns;
  } else return finalColumns;
};

const getCurriculumClassesColumnList = ({
  selectedCurriculumObj,
  excludedColumnIds = [],
  customProps = {},
  configuredColumns = [],
  showConfigurableColumns = false,
  t,
  studentsConfigurationStatus = true,
  selectedCurriculumProgramId,
  isLearningCourseEnabled,
  isAccountConfigurationEnabled,
  isAccountPortal,
}) => {
  const { isDP, isMYP, isPYP } = selectedCurriculumObj;
  const isActionColumnRequired =
    canManageClassRoster({
      curriculumProgramId: selectedCurriculumProgramId,
      isAccountPortal,
    }) ||
    canResetStudentCodeAndFamilyInviteInSchoolRoster(
      isAccountPortal ? undefined : selectedCurriculumProgramId
    ) ||
    canViewStudentCodeAndFamilyInviteInSchoolRoster(
      isAccountPortal ? undefined : selectedCurriculumProgramId
    );

  const isCheckboxColumnVisible = isBulkActionsEnabled();

  const requiredColumns = [
    {
      label: "Class Name",
      locale: "schoolSetup:class_name",
      id: "name",
      type: isAccountConfigurationEnabled ? "CUSTOM" : "NAMEWITHIMAGE",
      isSticky: true,
      sortType: "toggle",
      style: { minWidth: "300px", maxWidth: "500px" },
      entity: "TITLE",
    },
    ...(isLearningCourseEnabled
      ? [
          {
            label: "Course Name",
            locale: "schoolSetup:course_name",
            id: "learningCourse",
            type: "TEXTCOLUMN",
          },
        ]
      : []),
    ...(isActionColumnRequired
      ? [
          {
            id: "action",
            type: "CUSTOM",
            style: { width: "60px" },
            alignment: "center",
          },
        ]
      : []),
  ];

  const classCheckboxColumn = {
    id: "rowSelection",
    type: "CUSTOM",
    style: { width: "44px" },
    visible: isCheckboxColumnVisible,
    isSticky: true,
    alignment: "center",
    showCustomHeader: true,
  };

  const classColumns = [
    {
      label: "Subject group",
      locale: "unitPlan:subject_group",
      id: "subjectGroup",
      type: "TEXTCOLUMN",
      style: { maxWidth: "600px" },
      visible: (isDP || isMYP) && !isLearningCourseEnabled,
    },
    {
      label: "Subject",
      locale: "common:subject",
      id: "subject",
      type: "CUSTOM",
      style: { minwidth: "450px" },
      visible: !isPYP && !isLearningCourseEnabled,
    },
    {
      label: "Academic years",
      locale: "common:academic_year_one_or_more",
      id: "academicYears",
      type: "CUSTOM",
      visible: isDP,
      style: { minWidth: "300px" },
    },
    {
      label: t("common:total_with_label", {
        label: t("common:staff"),
      }),
      id: "staffs",
      type: "CUSTOM",
      visible: true,
      emptyTextStyle: { color: colors.textDisabled },
      style: { minWidth: "200px" },
      alignment: "center",
    },
    {
      label: "Grades",
      locale: "common:grade_plural",
      id: "grades",
      type: "ARRAYCOLUMNWITHOVER",
      visible: !isLearningCourseEnabled,
      emptyTextStyle: { color: colors.textDisabled },
      style: { minWidth: "200px" },
    },

    {
      label: t("common:total_with_label", {
        label: t("common:student_plural"),
      }),
      id: "students",
      type: "CUSTOM",
      visible: studentsConfigurationStatus,
      emptyTextStyle: { color: colors.textDisabled, paddingLeft: "10px" },
      alignment: "center",
      style: { minWidth: "200px" },
    },
    {
      label: "Class UID",
      locale: "schoolSetup:class_id",
      id: "sourcedId",
      type: "TEXTCOLUMN",
      style: { minWidth: "300px", maxWidth: "600px" },
      visible: true,
    },
    {
      label: "Subject Level",
      locale: "common:subject_level",
      id: "subjectLevel",
      type: "CUSTOM",
      style: { minWidth: "200px" },
      visible: isDP && !isLearningCourseEnabled,
    },
    {
      label: "Response Language",
      locale: "common:response_language",
      id: "responseLanguage",
      type: "TEXTCOLUMN",
      style: { maxWidth: "600px" },
      visible: isDP,
    },
  ];

  return getFinalColumnList({
    columnList: classColumns,
    excludedColumnIds,
    configuredColumns,
    showConfigurableColumns,
    customProps,
    requiredColumns,
    checkboxColumn: classCheckboxColumn,
  });
};

const getAdditionalFieldsColumnList = ({
  style,
  studentAdditionalFieldsConfig,
}) => {
  const {
    PROFILE_ADDITIONAL_FIELDS,
    STUDENT_ADDITIONAL_FIELDS_TITLE_MAPPING,
    getLabelForPersonalInfoAdditionalField,
  } = require("StudentPortfolio/routes/PortfolioDetailsV2/modules/Utils");

  const shouldShowAdditionalFieldColumns = ACLStore.can(
    "FeatureFlag:EnableAdditionalFieldsInSchoolSetup"
  );
  if (!shouldShowAdditionalFieldColumns) {
    return [];
  }

  return _.map(_.keys(PROFILE_ADDITIONAL_FIELDS), key => {
    const field = PROFILE_ADDITIONAL_FIELDS[key];
    const isURLField = _.get(
      studentAdditionalFieldsConfig,
      [key, "isURLField"],
      false
    );

    return {
      locale: getLabelForPersonalInfoAdditionalField(field),
      /**
       * NOTE: Some additional fields may not have any locale to read from configuration,
       * so this label would be used as column value
       */
      label: "",
      id: STUDENT_ADDITIONAL_FIELDS_TITLE_MAPPING[key],
      type: isURLField ? "CUSTOM" : "TEXTCOLUMN",
      visible: ACLStore.can(field.displayPerm),
      style,
    };
  });
};

export const getCurriculumStudentsAdditionalFieldsData = ({ otherDetails }) => {
  const {
    STUDENT_ADDITIONAL_FIELDS_TITLE_MAPPING,
  } = require("StudentPortfolio/routes/PortfolioDetailsV2/modules/Utils");
  const defaultValue = "-";

  return _.reduce(
    _.keys(STUDENT_ADDITIONAL_FIELDS_TITLE_MAPPING),
    (result, key) => {
      const fieldName = STUDENT_ADDITIONAL_FIELDS_TITLE_MAPPING[key];
      const fieldValue = _.get(otherDetails, fieldName);
      return {
        ...result,
        [fieldName]: fieldValue || defaultValue,
      };
    },
    {}
  );
};

export const getCurriculumClassesColumnListMemoised = _.memoize(
  params => getCurriculumClassesColumnList(params),
  params => JSON.stringify(params)
);

export const getStaffColumnList = ({
  isClickableRow,
  t,
  showConfigurableColumns = false,
  selectedCurriculumProgramId,
  isDevUser,
  excludedColumnIds = [],
  configuredColumns = [],
  customProps = {},
}) => {
  const isStaffPermissionEnabled = ACLStore.isStaffPermissionEnabled(
    MODULES.SCHOOL_SETUP.id
  );

  const isRnPConfigurationEnabled = ACLStore.can(
    ENABLE_ROLES_AND_PERMISSIONS_CONFIGURATION
  );

  const isActionTabVisible =
    !showConfigurableColumns &&
    (canManageSchoolRoster(selectedCurriculumProgramId) ||
      canImpersonateStaff(isDevUser) ||
      canManageSuperAdmins() ||
      canLogoutStaff());

  const accountLevelLabelLocale = getRnPLevelLabelLocale("ACCOUNT");

  const programmeLevelLabelLocale = getRnPLevelLabelLocale("PROGRAMME");

  const isUserPrefixEnabled = getIsUserPrefixEnabled();
  const isUserPronounsEnabled = getIsUserPronounsEnabled();

  const requiredColumns = [
    {
      label: "User Name",
      locale: "common:staff_name",
      id: "name",
      type: "NAMEWITHIMAGE",
      style: { minWidth: "360px", maxWidth: "500px", zIndex: 11 },
      isSticky: true,
      sortType: "dropdown",
      hasSortingEnabled: true,
      sortByOptions: getUserSortOptions({
        sortOptions: USER_NAME_SORT_OPTIONS_V2,
        keyToMap: "sortEntity",
        type: "staff",
      }),
      entity: "NAME",
      showArchivedLabel: false,
      customCellStyle: { ...(!isClickableRow && { cursor: "default" }) },
      profileCascadeWrapper: UserAccessPoint,
      hideTooltip: isAccessPointEnable(STAFF, ACCESS_POINT_MODULE.ADMIN_PORTAL),
      visible: true,
    },
    ...(isActionTabVisible
      ? [
          {
            id: "action",
            type: "CUSTOM",
            style: { width: "60px" },
            alignment: "center",
          },
        ]
      : []),
  ];

  const isMfaEnabled = getIsMfaEnabled();

  const staffColumns = [
    {
      label: "Staff UID",
      locale: "common:uid",
      id: "sourceId",
      type: "TEXTCOLUMN",
      style: { maxWidth: "600px" },
      visible: true,
    },
    {
      label: "Role",
      locale: isStaffPermissionEnabled ? "common:system_role" : "common:role",
      id: "role",
      type: "TEXTCOLUMN",
      visible: !isRnPConfigurationEnabled,
    },
    {
      label: "Is MFA Enabled",
      locale: "common:2fa",
      id: "isMfaEnabled",
      type: "TEXTCOLUMN",
      visible: isMfaEnabled,
    },
    {
      label: "Display Role",
      locale: "common:display_title",
      id: "displayRole",
      type: "CUSTOM",
      visible: isRnPConfigurationEnabled,
    },
    {
      id: "rnpRoles",
      label: t("common:role_one_or_more"),
      type: "CUSTOM",
      visible: isRnPConfigurationEnabled,
    },
    {
      id: "accountRole",
      label: t(`acl:level_label_with_role`, {
        label: t(`acl:${accountLevelLabelLocale}`, {
          defaultValue: accountLevelLabelLocale,
        }),
      }),
      type: "CUSTOM",
      visible: false,
    },
    {
      id: "programmeRole",
      label: t("common:programme_role_one_or_more", {
        label: t(`acl:${programmeLevelLabelLocale}`, {
          defaultValue: programmeLevelLabelLocale,
        }),
      }),
      type: "CUSTOM",
      visible: false,
    },
    ...(isStaffPermissionEnabled
      ? [
          {
            label: "Display Role",
            locale: "common:display_title",
            id: "displayRole",
            type: "CUSTOM",
            visible: !isRnPConfigurationEnabled,
          },
        ]
      : []),
    {
      label: t("configuration:classes"),
      id: "course",
      type: "CUSTOM",
      visible: true,
      emptyTextStyle: { color: colors.textDisabled, minWidth: "400px" },
      style: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
      },
    },
    {
      label: "Programme",
      locale: "common:programme",
      id: "programme",
      type: "CUSTOM",
      visible: !isRnPConfigurationEnabled,
    },
    {
      label: "Preferred name",
      locale: "common:preferred_name",
      id: "preferredName",
      type: "TEXTCOLUMN",
      style: { textAlign: "center" },
      visible: isUserPrefixEnabled,
    },
    {
      label: "First name",
      locale: "common:first_name",
      id: "firstName",
      type: "TEXTCOLUMN",
      style: { textAlign: "center" },
      visible: true,
    },
    {
      label: "Middle name",
      locale: "common:middle_name",
      id: "middleName",
      type: "TEXTCOLUMN",
      style: { textAlign: "center" },
      visible: isUserMiddleNameEnabled(),
    },
    {
      label: "Last name",
      locale: "common:last_name",
      id: "lastName",
      type: "TEXTCOLUMN",
      style: { textAlign: "center" },
      visible: true,
    },
    {
      label: "Prefix",
      locale: "common:prefix",
      id: "prefix",
      type: "TEXTCOLUMN",
      style: { textAlign: "center" },
      visible: isUserPrefixEnabled,
    },
    {
      label: "Suffix",
      locale: "common:suffix",
      id: "suffix",
      type: "TEXTCOLUMN",
      style: { textAlign: "center" },
      visible: isUserPrefixEnabled,
    },
    {
      label: "pronouns",
      locale: "common:pronouns",
      id: "pronouns",
      type: "TEXTCOLUMN",
      style: { textAlign: "center" },
      visible: isUserPrefixEnabled && isUserPronounsEnabled,
    },
  ];

  return getFinalColumnList({
    columnList: staffColumns,
    excludedColumnIds,
    configuredColumns,
    showConfigurableColumns,
    customProps,
    requiredColumns,
  });
};

export const getStaffColumnListMemoised = _.memoize(
  params => getStaffColumnList(params),
  params => JSON.stringify(params)
);

const getCurriculumStudentsColumnList = ({
  selectedCurriculum,
  excludedColumnIds = [],
  includedColumnIds = [],
  customProps = {},
  configuredColumns = [],
  showConfigurableColumns = false,
  selectedCurriculumProgramId,
  t,
  isFamilyInviteOptionsDisabled = false,
  studentAdditionalFieldsConfig,
}) => {
  // If no curriculum type sending all columns for "All Students" section
  const { isDP } = getSelectedCurriculumObject({
    selectedCurriculum,
  });

  const isPronounsVisible = getIsStudentPronounsEnabled();

  // check if student middle name is enabled
  const isStudentMiddleNameEnabled = getIsStudentMiddleNameEnabled();

  // check if preferred name, suffix, pronouns for students is enabled
  const isUserMiddleNameEnabled = getIsUserMiddleNameEnabled();

  // check if prefix for users is enabled
  const isUserPrefixEnabled = getIsUserPrefixEnabled();

  const additionalFieldsStyle = {
    maxWidth: "120px",
  };

  const isRnPConfigurationEnabled = ACLStore.can(
    ENABLE_ROLES_AND_PERMISSIONS_CONFIGURATION
  );

  const isEnrollWithdrawalDateEnabled = getIsEnrollWithdrawalDateEnabled();

  const programmeLabel = getRnPLevelLabelLocale("PROGRAMME");
  const programmeOrSchoolLocalized = isRnPConfigurationEnabled
    ? `acl:${programmeLabel}`
    : "common:programme";

  const requiredColumns = [
    {
      label: "Student Name",
      locale: "common:student_name",
      id: "name",
      type: "CUSTOM",
      style: { maxWidth: "600px", minWidth: "338px" },
      isSticky: true,
      sortType: "dropdown",
      hasSortingEnabled: true,
      sortByOptions: getUserSortOptions({
        sortOptions: USER_NAME_SORT_OPTIONS_V2,
        keyToMap: "sortEntity",
        type: "student",
      }),
      profileCascadeWrapper: UserAccessPoint,
      hideTooltip: isAccessPointEnable(
        STUDENT,
        ACCESS_POINT_MODULE.ADMIN_PORTAL
      ),
      entity: "NAME",
      showArchivedLabel: false,
      customCellStyle: {
        cursor: "pointer",
      },
    },
    {
      id: "action",
      type: "CUSTOM",
      style: { width: "60px" },
      alignment: "center",
    },
  ];

  const studentCheckboxColumn = {
    id: "rowSelection",
    type: "CUSTOM",
    style: { width: "44px" },
    entity: "UID",
    visible: isBulkActionsEnabled(),
    isSticky: true,
    alignment: "center",
    showCustomHeader: true,
  };

  const studentColumns = [
    {
      label: "Student UID",
      locale: "common:uid",
      id: "sourceId",
      type: "TEXTCOLUMN",
      style: { maxWidth: "600px" },
      sortType: "toggle",
      entity: "UID",
      visible: true,
    },

    {
      label: "Year group",
      locale: "common:year_group",
      id: "yearGroup",
      type: "CUSTOM",
      style: { maxWidth: "600px" },
      visible: true,
    },
    {
      label: "Programme",
      locale: programmeOrSchoolLocalized,
      id: "programme",
      type: "TEXTCOLUMN",
      visible:
        _.isEmpty(selectedCurriculum) ||
        _.includes(includedColumnIds, "programme"),
    },
    {
      label: t("common:total_with_label", {
        label: t("common:classes"),
      }),
      id: "course",
      type: "CUSTOM",
      visible: true,
      emptyTextStyle: { color: colors.textDisabled, minWidth: "400px" },
      style: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
      },
    },
    {
      label: "Family invite code",
      locale: "common:family_invite_code",
      id: "familyInviteCode",
      type: "CUSTOM",
      visible:
        canViewStudentCodeAndFamilyInviteInSchoolRoster(
          selectedCurriculumProgramId
        ) && !isFamilyInviteOptionsDisabled,
    },
    {
      label: "Student sign in code",
      locale: "common:student_sign_in_code",
      id: "studentSignInCode",
      type: "CUSTOM",
      visible: canViewStudentCodeAndFamilyInviteInSchoolRoster(
        selectedCurriculumProgramId
      ),
    },
    {
      label: "Family Members",
      locale: "common:family_member_plural",
      id: "families",
      type: "CUSTOM",
      visible: true,
      style: { textAlign: "center" },
    },
    {
      label: "Homeroom",
      locale: getIsMultipleHomeroomAdvisorsEnabled()
        ? "attendance:homeroom_advisor_other"
        : "attendance:homeroom_advisor",
      id: "homeroom",
      type: getIsMultipleHomeroomAdvisorsEnabled()
        ? "ARRAYCOLUMNWITHOVER"
        : "CUSTOM",
      avatarStyles: { randomizeColor: true, shade: "light", shape: "square" },
      visible: isHomeroomEnabled(),
      emptyTextLocale: "common:not_assigned",
    },

    {
      label: "dob",
      locale: "common:dob",
      id: "dob",
      type: "TEXTCOLUMN",
      style: { textAlign: "center" },
      visible: true,
    },
    {
      label: "enrollmentDate",
      locale: "integration:enrollment_date_student_details",
      id: "enrollmentDate",
      type: "CUSTOM",
      style: { textAlign: "center" },
      visible: isEnrollWithdrawalDateEnabled,
    },
    {
      label: "withdrawalDate",
      locale: "common:withdrawal_date",
      id: "withdrawalDate",
      type: "CUSTOM",
      style: { textAlign: "center" },
      visible: isEnrollWithdrawalDateEnabled,
    },
    {
      label: "primaryLanguage",
      locale: "common:first_language",
      id: "primaryLanguage",
      type: "TEXTCOLUMN",
      style: { textAlign: "center" },
      visible: true,
    },
    {
      label: "secondaryLanguage",
      locale: "common:second_language",
      id: "secondaryLanguage",
      type: "TEXTCOLUMN",
      style: { textAlign: "center" },
      visible: true,
    },
    {
      label: "primaryNationality",
      locale: "common:first_nationality",
      id: "primaryNationality",
      type: "TEXTCOLUMN",
      style: { textAlign: "center" },
      visible: true,
    },
    {
      label: "secondaryNationality",
      locale: "common:second_nationality",
      id: "secondaryNationality",
      type: "TEXTCOLUMN",
      style: { textAlign: "center" },
      visible: true,
    },
    {
      label: "First name",
      locale: "common:first_name",
      id: "firstName",
      type: "TEXTCOLUMN",
      style: { textAlign: "center" },
      visible: true,
    },
    {
      label: "Middle name",
      locale: "common:middle_name",
      id: "middleName",
      type: "TEXTCOLUMN",
      style: { textAlign: "center" },
      visible: isStudentMiddleNameEnabled,
    },
    {
      label: "Last name",
      locale: "common:last_name",
      id: "lastName",
      type: "TEXTCOLUMN",
      style: { textAlign: "center" },
      visible: true,
    },
    {
      label: "gender",
      locale: "common:gender",
      id: "gender",
      type: "TEXTCOLUMN",
      style: { textAlign: "center" },
      visible: true,
    },
    {
      label: "pronouns",
      locale: "common:pronouns",
      id: "pronouns",
      type: "TEXTCOLUMN",
      style: { textAlign: "center" },
      visible: isPronounsVisible && isUserMiddleNameEnabled,
    },
    {
      label: "Prefix",
      locale: "common:prefix",
      id: "prefix",
      type: "TEXTCOLUMN",
      style: { textAlign: "center" },
      visible: isUserPrefixEnabled,
    },
    {
      label: "Suffix",
      locale: "common:suffix",
      id: "suffix",
      type: "TEXTCOLUMN",
      style: { textAlign: "center" },
      visible: isUserMiddleNameEnabled,
    },
    {
      label: "Preferred name",
      locale: "common:preferred_name",
      id: "preferredName",
      type: "TEXTCOLUMN",
      style: { textAlign: "center" },
      visible: isUserMiddleNameEnabled,
    },
    {
      label: "Registration category",
      locale: "common:registration_category",
      id: "category",
      type: "TEXTCOLUMN",
      visible: isDP,
    },
    ...getAdditionalFieldsColumnList({
      style: additionalFieldsStyle,
      studentAdditionalFieldsConfig,
    }),
  ];

  return getFinalColumnList({
    columnList: studentColumns,
    excludedColumnIds,
    configuredColumns,
    showConfigurableColumns,
    customProps,
    requiredColumns,
    checkboxColumn: studentCheckboxColumn,
  });
};

export const getCurriculumStudentsColumnListMemoised = _.memoize(
  params => getCurriculumStudentsColumnList(params),
  params => JSON.stringify(params)
);

//Can't memoize this function as settingsObj is dynamic
export const getConfiguredColumns = ({
  selectedCurriculumProgramId,
  type,
  userId,
  isMYP,
}) => {
  const {
    tableToSettingsMap,
    defaultSetupTableColumns,
  } = getConfigureColumnsConfig(isMYP);

  const settingName = _.get(tableToSettingsMap, [type]);

  const settingsObj = getSettingValue({
    userId,
    name: settingName,
    readFromUserAndOrgLevel: true,
  });

  const settingValueId = selectedCurriculumProgramId || "ALL"; // ALL is for "All Students" section
  const configuredColumns = _.get(
    settingsObj,
    [settingValueId],
    defaultSetupTableColumns[type]
  );
  return { settingsObj, configuredColumns };
};

export const onUpdateSettings = ({ value, type }) => {
  return async (dispatch, getState) => {
    const { tableToSettingsMap } = getConfigureColumnsConfig();
    const settingName = _.get(tableToSettingsMap, [type]);
    dispatch(
      updateSettings({
        settings: [{ name: settingName, value: JSON.stringify(value) }],
        showToastMsg: false,
      })
    );
  };
};

export const donwloadClassRosterDataInBulk = ({
  toggleLoadingScreen,
  params,
  selectedCurriculumLabel,
  title,
  customSheetName = undefined,
  shouldDownloadFromURL = false,
  isFilteredData = false,
  activityLogModule = null,
}) => {
  return async (dispatch, getState) => {
    if (toggleLoadingScreen) toggleLoadingScreen();
    try {
      const userInfo = getUserInfo();
      const state = getState();
      const organizationId = userInfo.org_id;
      const data = await client.query({
        query: getOgranizationDataQuery,
        variables: {
          organizationId,
          ...params,
        },
        fetchPolicy: "network-only",
      });
      const downloadData = _.get(
        data,
        "data.node.organizationDataBulkDownload",
        {}
      );
      const currDate = moment().format("D MMM YYYY");
      const sheetName =
        customSheetName ||
        `${selectedCurriculumLabel} ${title} - (${currDate})`;
      const orgName = _.get(data, "data.node.name", "");
      const subFileName = `- ${orgName} (${currDate})`;
      let fileName = `${selectedCurriculumLabel} ${title} ${subFileName}`;

      const fields = _.get(downloadData, "fields", []);

      const columnWidthConfig = _.map(fields, fieldName =>
        _.get(CLASS_ROSTER_CSV_COLUMN_WIDTHS, [title, fieldName], 25)
      );

      if (title === "Family") {
        const fetchType = _.get(params, "filters.familyFetchType");
        if (selectedCurriculumLabel) {
          selectedCurriculumLabel = ` ${selectedCurriculumLabel}`;
        }
        const midFileName =
          fetchType === "unconnected"
            ? "students with no family added"
            : "family members";
        fileName = `List of${selectedCurriculumLabel} ${midFileName} ${subFileName}`;
      }
      if (isFilteredData) {
        fileName = `${fileName} filtered list`;
      }

      const downloadUrl = _.get(downloadData, "url");
      if (activityLogModule) {
        logBulkActionActivity({
          input: {
            operation: "READ",
            module: activityLogModule,
            activityType: "BULK_ACTION",
            activityMessage: `DOWNLOADED_${title.toUpperCase()}`,
            description: `Downloaded ${title} in bulk.`,
            curriculumProgramId: params.curriculumProgramId,
            metadata: {
              curriculumProgramId: params.curriculumProgramId,
              academicYearId: params.academicYearId,
            },
          },
        });
      }
      if (shouldDownloadFromURL && downloadUrl) {
        return dispatch(
          downloadFromUrl({
            attachment: {
              url: downloadUrl,
              name: fileName,
              mimeType: "application/xlsx",
            },
            shouldAskForSave: true,
          })
        );
      }
      return exportData({
        data: downloadData,
        outputFormat: "XLSX",
        fileType: "classRosterDataBulkDownload",
        fileName,
        sheetName: customSheetName || sheetName,
        columnWidthConfig,
      });
    } catch (error) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    } finally {
      if (toggleLoadingScreen) toggleLoadingScreen();
    }
  };
};

export const getInitialSchoolEntityModalState = ({ modalType }) => {
  return _.get(initialState, `schoolEntityModal.${modalType}`, {});
};

const REDUCER_HANDLERS = {
  [TOGGLE_CONFIGURE_COLUMNS_MODAL]: state => {
    const showConfigureColumnsModal = state.showConfigureColumnsModal;
    return update(state, {
      showConfigureColumnsModal: { $set: !showConfigureColumnsModal },
    });
  },
  [UPDATE_SORT_ORDER]: (state, action) => {
    const {
      tab,
      sortObj: { id, menuItemEntity, sortDirection },
    } = action.payload;
    const updatedSortObj = {
      [id]: { direction: sortDirection, menuItemEntity },
    };
    return update(state, {
      sortFields: { [tab]: { $set: updatedSortObj } },
    });
  },
  [SCHOOL_ENTITY_MODAL_INIT_STATE]: state => {
    return update(state, {
      schoolEntityModal: { $set: initialState.schoolEntityModal },
    });
  },
  [UPDATE_SCHOOL_ENTITY_MODAL_DATA]: (state, action) => {
    const { modalType, modalTab, params } = action.payload;

    _.forEach(params, (value, key) => {
      state = update(state, {
        schoolEntityModal: {
          [modalType]: { [modalTab]: { [key]: { $set: value } } },
        },
      });
    });

    return state;
  },
  [UPDATE_SCHOOL_ENTITY_MODAL_FILTERS]: (state, action) => {
    const params = action.payload;
    _.forEach(params, (value, key) => {
      state = update(state, {
        schoolEntityModal: {
          filters: { [key]: { $set: value } },
        },
      });
    });
    return state;
  },
  [RESET_SCHOOL_ENTITY_MODAL_FILTERS]: (state, action) => {
    return update(state, {
      schoolEntityModal: { filters: { $set: {} } },
    });
  },
  [UPDATE_SELECTED_CURRICULUM]: (state, action) => {
    const newSelectedCurriculum = action.payload;
    return update(state, {
      schoolEntityModal: {
        selectedCurriculum: { $set: newSelectedCurriculum },
      },
    });
  },
  [UPDATE_ADD_ENTITY_MODAL_SELECTED_ITEMS]: (state, action) => {
    const { data } = action;
    return update(state, {
      schoolEntityModal: {
        addEntityModal: { selectedItems: { $set: data } },
      },
    });
  },
  [UPDATE_ADD_ENTITY_MODAL_EXCLUDED_ITEMS]: (state, action) => {
    const { data } = action;
    return update(state, {
      schoolEntityModal: {
        addEntityModal: { excludedItems: { $set: data } },
      },
    });
  },
  [UPDATE_ADD_ENTITY_MODAL_SELECTED_ITEMS_COUNT]: (state, action) => {
    const { data } = action;
    return update(state, {
      schoolEntityModal: {
        addEntityModal: { selectedItemsCount: { $set: data } },
      },
    });
  },
  [UPDATE_ADD_ENTITY_MODAL_SELECTED_ALL_OPTIONS]: (state, action) => {
    const { data } = action;
    return update(state, {
      schoolEntityModal: {
        addEntityModal: { selectedAllOptions: { $set: data } },
      },
    });
  },
  [UPDATE_ADD_ENTITY_MODAL_SELECTED_ITEMS_AND_SUBJECT_LEVELS_MAPPING]: (
    state,
    action
  ) => {
    const { data } = action;
    state = update(state, {
      schoolEntityModal: {
        addEntityModal: {
          selectedItemsAndSubjectLevelsMapping: {
            $set: data,
          },
        },
      },
    });
    return state;
  },
  [UPDATE_ADD_ENTITY_MODAL_SHOW_ADDITIONAL_FILTERS]: (state, action) => {
    const { data } = action;
    return update(state, {
      schoolEntityModal: {
        showAdditionalFiltersInAddEntityModal: { $set: data },
      },
    });
  },
  [UPDATE_ADD_ENTITY_MODAL_SELECTED_ITEMS_LIST]: (state, action) => {
    const { data } = action;
    return update(state, {
      schoolEntityModal: {
        addEntityModal: { selectedItemsList: { $set: data } },
      },
    });
  },
  [RESET_ADD_ENTITY_MODAL_OBJ]: state => {
    return update(state, {
      schoolEntityModal: {
        addEntityModal: { $set: initialState.schoolEntityModal.addEntityModal },
      },
    });
  },
  [ENTITY_EMAIL_ALREADY_EXISTS_USER_DATA]: (state, action) => {
    const { entityType, entityId } = action.payload;
    return update(state, {
      entityEmailAlreadyExistsUserData: {
        entityType: { $set: entityType },
        entityId: { $set: entityId },
      },
    });
  },
  [RESET_ENTITY_EMAIL_ALREADY_EXISTS_USER_DATA]: state => {
    return update(state, {
      entityEmailAlreadyExistsUserData: {
        $set: initialState.entityEmailAlreadyExistsUserData,
      },
    });
  },
};

const initialState = {
  showConfigureColumnsModal: false,
  sortFields: {
    classes: { TITLE: { direction: "ASC", menuItemEntity: "TITLE" } },
    staff: { NAME: { direction: "ASC", menuItemEntity: "FIRST_NAME" } },
    students: { NAME: { direction: "ASC", menuItemEntity: "FIRST_NAME" } },
    visitors: { NAME: { direction: "ASC", menuItemEntity: "FIRST_NAME" } },
    casExternalSupervisor: {
      NAME: { direction: "ASC", menuItemEntity: "FIRST_NAME" },
    },
  },
  schoolEntityModal: {
    COURSE: {
      BASIC_DETAILS: {},
      ADD_STUDENTS: {
        addedItems: [],
        totalEntityItemsCount: 0,
        removedItems: [],
        selectedAllOptions: false,
      },
      ADD_STAFF: {
        addedItems: [],
        totalEntityItemsCount: 0,
        removedItems: [],
        selectedAllOptions: false,
        defaultTeacherRoleId: null,
      },
    },
    LEARNING_COURSE: {
      BASIC_DETAILS: {},
      ADD_STAFF: {
        addedItems: [],
        totalEntityItemsCount: 0,
        removedItems: [],
        selectedAllOptions: false,
        defaultTeacherRoleId: null,
      },
      ADD_CLASS: {
        addedItems: [],
        selectedCurriculums: [],
        removedItems: [],
        curriculumWiseCountObj: {},
        totalEntityItemsCount: 0,
      },
    },
    STUDENT: {
      BASIC_DETAILS: {},
      PERSONAL_DETAILS: {},
      ADD_TO_CLASSES: {
        addedItems: [],
        selectedCurriculums: [],
        removedItems: [],
        curriculumWiseCountObj: {},
        totalEntityItemsCount: 0,
      },
      HOMEROOM_ADVISOR: { addedItems: [] },
    },
    STAFF: {
      BASIC_DETAILS: {},
      ROLES_AND_PROGRAMMES: {
        addedItems: [],
        removedItems: [],
      },
      ADD_TO_CLASSES: {
        addedItems: [],
        selectedCurriculums: [],
        removedItems: [],
        curriculumWiseCountObj: {},
        defaultTeacherRoleId: null,
      },
    },
    VISITOR: {
      BASIC_DETAILS: {},
      ADD_CYCLES: { addedItems: [] },
    },
    filters: {},
    selectedCurriculum: {},
    addEntityModal: {
      selectedItems: [],
      selectedItemsList: [], // Using this to store the selected entity items' data because if a user applies a search filter, selects an item, and then removes the filter, we lack a way to retrieve that selected item or items' data
      excludedItems: [],
      selectedItemsCount: 0,
      selectedAllOptions: false,
      selectedItemsAndSubjectLevelsMapping: {},
    },
    showAdditionalFiltersInAddEntityModal: false, // Handles show/hide of additional filters in the add students modal
  },
  entityEmailAlreadyExistsUserData: {
    /**
     * Stores user type and user Id when adding a user (staff/visitor/student) with an email that already exists.
     * Used to open the appropriate edit modal (staff/visitor/student) with entity ID.
     * Handles cases where:
     * 1. The user exists in a previous or future academic year
     * 2. A staff member is being added who is currently a visitor in the organization
     */
  },
};

export default function myReducer(state = initialState, action) {
  const handler = REDUCER_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
